const _excluded = ["collapsed", "index"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from '@adsk/alloy-react-content-loader';
const widths = [113, 53, 88, 60, 130, 61, 124, 112, 124, 118];
const SideNavigationItemLoader = _ref => {
  let {
      collapsed,
      index
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ContentLoader, _extends({
    width: collapsed ? 24 : 196,
    height: 24
  }, props), !collapsed && /*#__PURE__*/React.createElement("rect", {
    x: "36",
    y: "8",
    rx: "4",
    ry: "4",
    width: widths[index % widths.length],
    height: "8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "12",
    ry: "12",
    width: "24",
    height: "24"
  }));
};
SideNavigationItemLoader.displayName = 'SideNavigationItemLoader';
SideNavigationItemLoader.propTypes = {
  collapsed: PropTypes.bool,
  /** The index of the loader, used to decide the width */
  index: PropTypes.number.isRequired
};
export default SideNavigationItemLoader;
//# sourceMappingURL=SideNavigationItemLoader.js.map